module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Warto\u015B\u0107 musi mie\u0107 warto\u015B\u0107 ".concat(args.maxValue, " lub wcze\u015Bniejsz\u0105.");
  },
  "rangeReversed": "Data rozpocz\u0119cia musi by\u0107 wcze\u015Bniejsza ni\u017C data zako\u0144czenia.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Warto\u015B\u0107 musi mie\u0107 warto\u015B\u0107 ".concat(args.minValue, " lub p\xF3\u017Aniejsz\u0105.");
  },
  "unavailableDate": "Wybrana data jest niedost\u0119pna."
};